
























































import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import ArrowRightInfoIcon from '@/components/icons/ArrowRightInfo.vue';
import BookmarkIcon from '@/components/icons/Bookmark.vue';
import StatusTag from '@/componentsV2/atoms/StatusTag/StatusTag.vue';

import { SpecialOfferTags } from '@/views/Offers/OfferDetail/OfferDetail.vue';

import {
  getRenewedLabel,
  EOfferRulesName,
  SpecialOfferTypeEnum
} from '@/models/offer';
import DateUtils from '@/utils/DateUtils';
import { FilledButton } from '@/components/molecules';
import CameraIcon from '@/components/icons/Camera.vue';
import EmptyImageIcon from '@/components/icons/EmptyImage.vue';
import OfferImageUpload from '@/componentsV2/molecules/Inputs/OfferImageUpload.vue';
import OfferTypeTag from '@/components/molecules/OfferTypeTag/OfferTypeTag.vue';

@Component({
  components: {
    Typography,
    GhostButton,
    ArrowRightInfoIcon,
    BookmarkIcon,
    StatusTag,
    FilledButton,
    CameraIcon,
    EmptyImageIcon,
    OfferImageUpload,
    OfferTypeTag
  }
})
export default class OfferItemWithoutImage extends Vue {
  @Prop() item!: any;

  instanceId = `offer-image-upload-${String(Math.random())}`;

  get renewedByRules() {
    return getRenewedLabel(
      this.item.rules.filter(
        (rule: any) => rule.name === EOfferRulesName.RENEWED_RULE
      )[0]
    );
  }

  get isBirthdayOffers() {
    return this.item.type === SpecialOfferTypeEnum.BIRTHDAY;
  }

  get date() {
    return `Created on ${DateUtils.formattedDate({
      date: this.item.createdAt,
      applyTimezone: true
    })}`;
  }

  handleStartUpload() {
    this.$showLoader();
  }

  handleEndUpload(data: { success: boolean }) {
    if (!data.success) return;

    this.$hideLoader();

    this.$notification('Offer image updated successfully');
    this.$emit('reloadList');
  }

  goToOfferDetail() {
    this.$router.push(`/special-coins-offers/${this.item.id}`);
  }
}
